import { Outlet, Link } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Providers } from '@/app/providers';
import { ErrorBoundary } from '@/shared/ui/atoms';
import { EmptyState } from '@/shared/ui/atoms';
import { ToastContainer } from '@/shared/ui/Toast';
import { CandidateQueryCompletionWatcher } from '@/features/outreach-candidates';

export function BootSplash() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
      aria-busy="true"
      aria-live="polite"
    >
      <span>로딩 중…</span>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <EmptyState
        icon="🔍"
        title="페이지를 찾을 수 없습니다"
        description="요청하신 페이지가 존재하지 않거나 이동되었습니다."
        action={
          <Link to="/" style={{ color: 'inherit', textDecoration: 'underline' }}>
            홈으로 돌아가기
          </Link>
        }
      />
    </div>
  );
}

export function RootComponent() {
  return (
    <Providers>
      <a href="#main-content" className="skip-link">
        본문으로 건너뛰기
      </a>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      <ToastContainer />
      <CandidateQueryCompletionWatcher />
      {import.meta.env.DEV && (
        <>
          <TanStackRouterDevtools position="bottom-right" />
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
        </>
      )}
    </Providers>
  );
}
